import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { client } from "../../client";
import "./AllTags.scss";
// import "./AllCategories.scss";
import { AppWrap } from "../../wrapper";
import { DotLoader } from "react-spinners";

const AllTags = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const tagQuery =
      '*[_type == "tag"]{title, slug, "count": count(*[_type == "blog" && references(^._id)])}';
    client.fetch(tagQuery).then((data) => {
      setTags(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="app__all-blogs">
      <h2 className="head-text">
        All <span>Tags</span>
      </h2>
      {loading ? (
        <div className="loader-container">
          <DotLoader color="#3498db" size={50} />
        </div>
      ) : (
        <div className="all-tags-list" style={{ marginTop: "2rem" }}>
          {tags.length === 0 ? (
            <p>No tags found.</p>
          ) : (
            tags
              .sort((a, b) => b.count - a.count)
              .map((tag, idx) => (
                <Link
                  to={`/tags/${tag.slug?.current || tag.title}`}
                  className="enhanced-tag-item"
                  style={{ textDecoration: "none" }}
                  key={tag.slug?.current || tag.title}
                >
                  <span className="enhanced-tag-title">
                    <span className="enhanced-tag-hash">#</span>
                    {tag.title}
                  </span>
                  <span className="enhanced-tag-count">{tag.count}</span>
                </Link>
              ))
          )}
        </div>
      )}
    </div>
  );
};

export default AppWrap(AllTags, "tags");
